/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import apiNew from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import {
 getIVAZFailure,
 GetIVAZPayload,
 getIVAZStart,
 getIVAZSuccess,
 sendIVAZFailure,
 SendIVAZPayload,
 sendIVAZStart,
 sendIVAZSuccess,
} from './ivazSlice';

function* getIVAZSaga({ payload }: { payload: GetIVAZPayload }) {
 try {
  const response: AxiosResponse<any> = yield call(apiNew.post, '/IVAZ/v1', {
   filters: [
    {
     field: 'ResultId',
     operator: 'eq',
     value: payload.resultId,
    },
   ],
  });

  yield put(
   getIVAZSuccess({
    ivaz: response.data,
   }),
  );
 } catch (error) {
  yield* errorHandling(error, getIVAZFailure);
 }
}
function* sendIVAZSaga({ payload }: { payload: SendIVAZPayload }) {
 console.log(payload);
 try {
  const response: AxiosResponse<any> = yield call(
   apiNew.post,
   '/IVAZ/v1/send',
   payload,
  );

  yield put(
   sendIVAZSuccess({
    ivaz: response.data,
    message: 'IVAZ sent successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, sendIVAZFailure);
 }
}

export function* watchIVAZSaga() {
 yield takeLatest(getIVAZStart, getIVAZSaga);
 yield takeLatest(sendIVAZStart, sendIVAZSaga);
}
